export default "__VITE_ASSET__VSyHKS7Z__"